import 'element-ui/packages/theme-chalk/src/date-picker.scss'
import DatePicker from './src/picker/date-picker'

/* istanbul ignore next */
DatePicker.install = function install(Vue) {
  Vue.component(DatePicker.name, DatePicker)
}

export default DatePicker
